import React from "react";
import { Link, useNavigate } from "react-router-dom";
import  "./NotFound.css";

const NotFound = () => {
    const navigate = useNavigate();
    const homeHandler = () => { 
        navigate("/maqs/english")
    }
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2>Page not found</h2>
      <p>The page you are looking for doesn't exist.</p>
      {/* <Link to="/maqs/english" style={{ textDecoration: "none", color: "green", fontSize: "18px" }}>
       Back to Home Page
      </Link> */}
      <button type="button" onClick={homeHandler} className="go-home-btn"> Back to Home Page</button>
    </div>
  );
};

export default NotFound;